import { RestrictedAPI } from '@fnol/library/src/api';
import { GenericObject } from '@fnol/library/src/lib';
import * as endpoints from './endpoints';

export const getCities = () => RestrictedAPI.get(endpoints.cities());
export const getPolicyDetails = (data: GenericObject) => RestrictedAPI.post(endpoints.policyDetails(), data);
export const getRoles = () => RestrictedAPI.get(endpoints.roles());
export const getPolicyRisks = () => RestrictedAPI.get(endpoints.risks());
export const getDocList = (id: string) => RestrictedAPI.get(endpoints.documents(id));
export const submitDocuments = (data: any) => RestrictedAPI.post(endpoints.addDocuments(), data);
export const submitTemporaryData = (data: GenericObject) => RestrictedAPI.post(endpoints.claimSubmit(), data);
export const getClaimConfirmation = (data: any) => RestrictedAPI.post(endpoints.claimConfirmation(), data);
export const getClaimConfirmationAnonymous = (data: any) =>
    RestrictedAPI.post(endpoints.claimConfirmationAnonymous(), data);
